export default __webpack_public_path__ + "static/pillar-5-5a96af98d996faa962137abdfb82a75d.jpg";